import i18n from "@/libs/i18n";
import store from "@/store";
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import axios from "@axios";
import Vue from 'vue'

export default function popups() {

 const deletePopup = function(id, url, redirect = '',  key='') {
    this.$swal({
        title: i18n.t('Are you sure?'),
        html: localStorage.getItem('vspanel-skin') == "dark" ? '<span style="color:#d0d2d6">' + i18n.t("You won't be able to revert this!") + '</span>' : i18n.t("You won't be able to revert this!") ,
        background: localStorage.getItem('vspanel-skin') == "dark" ? '#283046' : 'white',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('Yes, delete it!'),
        cancelButtonText: i18n.t('Cancel'),
        customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
    }).then(result => {
        if (result.value) {

            store.dispatch(url, { id: id })
            .then(response => { 
                    if (response.data.msg=="EXISTING_RECEIPT") {
                        throw new Error("No podrás borrar esta sucursal ya que existen facturas/gastos con vinculación.");
                    }
                    if (response.data.msg=="EXISTING_FOREIGN_KEY") {
                        throw new Error("Para borrar " + response.data.to_delete + ' tienes que borrar antes ' + response.data.before_delete + ' con vinculación.');
                    } 

                    this.$swal({
                    title: 'Success!',
                    text: response.data.msg,
                    icon: 'success',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                    })
                    .then(result =>{
                        if (result.value) {                           

                            if(redirect != ''){
                                this.$router.replace({ name: redirect }).then(() => {
                                    this.$toast({
                                        component: ToastificationContent,
                                        props: {
                                        title: i18n.t('Register Deleted'),
                                        icon: 'MailIcon',
                                        variant: 'success',
                                        },
                                    })
                                })
                            }

                            if (this.refetchData) {
                                this.refetchData()
                            }


                        }
                    })
                })
            .catch(error => {
                this.$swal({
                    title: 'Error!',
                    text: error.message,
                    icon: 'error',
                    customClass: {
                    confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                })
            })

        }
    })
}

 const deletePopupAxios = function(id, url, redirect = '') {
    this.$swal({
        title: i18n.t('Are you sure?'),
        html: localStorage.getItem('vspanel-skin') == "dark" ? '<span style="color:#d0d2d6">' + i18n.t("You won't be able to revert this!") + '</span>' : i18n.t("You won't be able to revert this!") ,
        background: localStorage.getItem('vspanel-skin') == "dark" ? '#283046' : 'white',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: i18n.t('Yes, delete it!'),
        cancelButtonText: i18n.t('Cancel'),
        customClass: {
        confirmButton: 'btn btn-primary',
        cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
    }).then(result => {
        if (result.value) {
            axios.delete(url, { id: id })
            .then(response => { 
                    if (response.data.msg=="EXISTING_RECEIPT") {
                        throw new Error("No podrás borrar ya que existen facturas/gastos con vinculación.");
                    }
                    if (response.data.msg=="EXISTING_FOREIGN_KEY") {
                        throw new Error("Para borrar " + response.data.to_delete + ' tienes que borrar antes ' + response.data.before_delete + ' con vinculación.');
                    } 

                    this.$swal({
                    title: 'Success!',
                    text: response.data.msg,
                    icon: 'success',
                    customClass: {
                        confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                    })
                    .then(result =>{
                        if (result.value) {                           

                            if(redirect != ''){
                                this.$router.replace({ name: redirect }).then(() => {
                                    this.$toast({
                                        component: ToastificationContent,
                                        props: {
                                        title: i18n.t('Register Deleted'),
                                        icon: 'MailIcon',
                                        variant: 'success',
                                        },
                                    })
                                })
                            }

                            if (this.refetchData) {
                                this.refetchData()
                            }

                            if (this.fetchData) {
                                this.fetchData()
                            }
                        }
                    })
                })
            .catch(error => {
                this.$swal({
                    title: 'Error!',
                    text: error.message,
                    icon: 'error',
                    customClass: {
                    confirmButton: 'btn btn-primary',
                    },
                    buttonsStyling: false,
                })
            })
        }
    })
}

const errorToast = function(text, title = "Error") {
    Vue.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: i18n.t(title),
          icon: 'AlertTriangleIcon',
          variant: 'danger',
          text: i18n.t(text),
        },
      })
}

const successToast = function(text, title = "Completado") {
    Vue.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: i18n.t(title),
          icon: 'CheckIcon',
          variant: 'success',
          text: i18n.t(text),
        },
      })
}

return {
    deletePopup,
    errorToast,
    successToast,
    deletePopupAxios
}

}